import type { GameWebSocket } from '../network/websocket';

/**
 * Send a generic world_event_action to the server.
 * `data` is event/action-specific (e.g. `{ text }` for `send_message`).
 */
export function sendWorldEventAction(
  ws: GameWebSocket,
  sessionId: string,
  action: string,
  data?: Record<string, unknown>,
): void {
  ws.send('world_event_action', data ? { sessionId, action, data } : { sessionId, action });
}
